import { render } from "./TrailerPage.vue?vue&type=template&id=ca596578"
import script from "./TrailerPage.vue?vue&type=script&lang=js"
export * from "./TrailerPage.vue?vue&type=script&lang=js"

import "./TrailerPage.vue?vue&type=style&index=0&id=ca596578&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__